import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  ref: "ghost",
  class: "viewer-overlay-ghost"
}
const _hoisted_2 = { class: "video-overlay__top-bar" }
const _hoisted_3 = { class: "viewer-overlay__bottom-bar" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ChevronDown = _resolveComponent("ChevronDown")
  const _component_ChevronUp = _resolveComponent("ChevronUp")
  const _component_NcButton = _resolveComponent("NcButton")
  const _component_ArrowExpand = _resolveComponent("ArrowExpand")
  const _component_ScreenShare = _resolveComponent("ScreenShare")
  const _component_VideoVue = _resolveComponent("VideoVue")
  const _component_EmptyCallView = _resolveComponent("EmptyCallView")
  const _component_LocalVideo = _resolveComponent("LocalVideo")
  const _component_LocalAudioControlButton = _resolveComponent("LocalAudioControlButton")
  const _component_LocalVideoControlButton = _resolveComponent("LocalVideoControlButton")
  const _component_TransitionWrapper = _resolveComponent("TransitionWrapper")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createElementVNode("div", {
        class: "viewer-overlay app-talk",
        style: _normalizeStyle($options.computedStyle)
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(["viewer-overlay__collapse", { collapsed: $data.isCollapsed }])
        }, [
          _createVNode(_component_NcButton, {
            variant: "secondary",
            class: "viewer-overlay__button",
            "aria-label": 
							$data.isCollapsed ? $options.t('spreed', 'Collapse') : $options.t('spreed', 'Expand')
						,
            onClick: _cache[0] || (_cache[0] = _withModifiers($event => ($data.isCollapsed = !$data.isCollapsed), ["stop"]))
          }, {
            icon: _withCtx(() => [
              (!$data.isCollapsed)
                ? (_openBlock(), _createBlock(_component_ChevronDown, {
                    key: 0,
                    size: 20
                  }))
                : (_openBlock(), _createBlock(_component_ChevronUp, {
                    key: 1,
                    size: 20
                  }))
            ]),
            _: 1
          }, 8, ["aria-label"])
        ], 2),
        _createVNode(_component_TransitionWrapper, { name: "slide-down" }, {
          default: _withCtx(() => [
            _withDirectives(_createElementVNode("div", {
              class: "viewer-overlay__video-container",
              tabindex: "0",
              onClick: _cache[1] || (_cache[1] = (...args) => ($options.maximize && $options.maximize(...args)))
            }, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_NcButton, {
                  variant: "secondary",
                  class: "viewer-overlay__button",
                  "aria-label": $options.t('spreed', 'Expand'),
                  onClick: _withModifiers($options.maximize, ["stop"])
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_ArrowExpand, { size: 20 })
                  ]),
                  _: 1
                }, 8, ["aria-label", "onClick"])
              ]),
              ($options.showLocalScreen)
                ? (_openBlock(), _createBlock(_component_ScreenShare, {
                    key: 0,
                    token: $props.token,
                    "local-media-model": $props.localModel,
                    "shared-data": $props.localSharedData
                  }, null, 8, ["token", "local-media-model", "shared-data"]))
                : ($props.model && $props.screens[$props.model.attributes.peerId])
                  ? (_openBlock(), _createBlock(_component_ScreenShare, {
                      key: 1,
                      token: $props.token,
                      "call-participant-model": $props.model,
                      "shared-data": $props.sharedData
                    }, null, 8, ["token", "call-participant-model", "shared-data"]))
                  : ($props.model)
                    ? (_openBlock(), _createBlock(_component_VideoVue, {
                        key: 2,
                        class: "viewer-overlay__video",
                        token: $props.token,
                        model: $props.model,
                        "shared-data": $props.sharedData,
                        "is-grid": "",
                        "un-selectable": "",
                        "hide-bottom-bar": "",
                        onClickVideo: $options.maximize
                      }, {
                        "bottom-bar": _withCtx(() => [...(_cache[2] || (_cache[2] = []))]),
                        _: 1
                      }, 8, ["token", "model", "shared-data", "onClickVideo"]))
                    : (_openBlock(), _createBlock(_component_EmptyCallView, {
                        key: 3,
                        "is-small": ""
                      })),
              ($props.localModel.attributes.videoEnabled)
                ? (_openBlock(), _createBlock(_component_LocalVideo, {
                    key: 4,
                    class: "viewer-overlay__local-video",
                    token: $props.token,
                    "show-controls": false,
                    "local-media-model": $props.localModel,
                    "local-call-participant-model": $props.localCallParticipantModel,
                    "is-small": "",
                    "un-selectable": ""
                  }, null, 8, ["token", "local-media-model", "local-call-participant-model"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_LocalAudioControlButton, {
                  class: "viewer-overlay__button",
                  token: $props.token,
                  conversation: $options.conversation,
                  model: $props.localModel,
                  variant: "secondary",
                  "disable-keyboard-shortcuts": ""
                }, null, 8, ["token", "conversation", "model"]),
                _createVNode(_component_LocalVideoControlButton, {
                  class: "viewer-overlay__button",
                  token: $props.token,
                  conversation: $options.conversation,
                  model: $props.localModel,
                  variant: "secondary",
                  "disable-keyboard-shortcuts": ""
                }, null, 8, ["token", "conversation", "model"])
              ])
            ], 512), [
              [_vShow, !$data.isCollapsed]
            ])
          ]),
          _: 1
        })
      ], 4)
    ]))
  ], 512))
}